import { createContext, useContext } from 'react';
import useAuth from '../hooks/useAuth';
import { getTemplate } from './config';

const TemplateContext = createContext({ id: 1, config: {} });

/**
 * useTemplate() — read the active template config anywhere inside UserLayout.
 *
 * Usage:
 *   const { id, config } = useTemplate();
 *   // config.pageBg, config.accent, config.cardBg, etc.
 *   // id === 2 → Template 2 is active
 */
export const useTemplate = () => useContext(TemplateContext);

/**
 * Wraps <Outlet /> in UserLayout.
 * - Applies pageBg to a full-height container so the colour covers the
 *   entire scroll area, not just the rendered content height.
 * - Exposes useTemplate() to every descendant.
 * - Pages that need only colour changes: zero changes needed.
 * - Pages that need a layout redesign: check `id` and render the right component.
 */
export default function TemplateProvider({ children }) {
  const { user } = useAuth();
  const id     = user?.dashboardTemplate ?? 1;
  const config = getTemplate(id);

  return (
    <TemplateContext.Provider value={{ id, config }}>
      {children}
    </TemplateContext.Provider>
  );
}
